import { render, staticRenderFns } from "./SmartSearchbar.vue?vue&type=template&id=28d4c2b8&scoped=true&"
import script from "./SmartSearchbar.vue?vue&type=script&lang=ts&"
export * from "./SmartSearchbar.vue?vue&type=script&lang=ts&"
import style0 from "./SmartSearchbar.vue?vue&type=style&index=0&id=28d4c2b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d4c2b8",
  null
  
)

export default component.exports